import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import InputAdornment from "@mui/material/InputAdornment";

import {
  dateNameFormat,
  formatDateName,
  getMomentDayFromInput,
} from "../../../tools";
import Schedule from "./DurationCalendar";

export default function DurationMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [text, setText] = useState(formatDateName(props.selectedDate));

  useEffect(() => {
    setText(formatDateName(props.selectedDate));
  }, [props.selectedDate]);

  // Open change date popover
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const handleFocus = (event) => {
    event.preventDefault();
    const { target } = event;
    const lastChar = target.value.length;
    target.focus();
    target.setSelectionRange(0, lastChar);
  };

  const handleTextChange = (event) => {
    const inputValue = event.target.value;
    setText(inputValue);
    const date = getMomentDayFromInput(inputValue);
    if (date && date.isAfter(props.minDate)) {
      setText(date.format(dateNameFormat));
      //setSelectedDate(date);
      props.handleDateChange(date);
    }
  };

  const handleScheduleChange = (event) => {
    setText(event.format(dateNameFormat));
    props.handleDateChange(event);
    handleClose(); // close the popover
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <TextField
          variant="standard"
          onClick={handleClick}
          label=""
          value={text}
          onFocus={handleFocus}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {props.startAdornment}
              </InputAdornment>
            ),
          }}
          onChange={handleTextChange}
        />
        <Popper
          open={open}
          anchorEl={anchorEl}
          placement={"bottom"}
          style={{ zIndex: 2000 }}
        >
          <Paper elevation={8}>
            <Schedule
              selectedDate={props.selectedDate}
              handleDateChange={handleScheduleChange}
              handleClose={handleClose}
              minDate={props.minDate}
            />
          </Paper>
        </Popper>
      </div>
    </ClickAwayListener>
  );
}
